// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Address_wrapper__nRv2v","tags":"Address_tags__AaGqv","content":"Address_content__D1GiK","name":"Address_name__ajsGL","phone":"Address_phone__9Ydl8"};